import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'

import { setItemState } from '../../modules/notes'

import List from './list'
import Note from './note'


export class Schedule extends Component {
  componentWillUnmount() {
    this.props.setItemState()
  }
  render() {
    return (
      <Switch>
        <Route exact path='/schedule' component={List} />
        <Route path='/schedule/:note_id' component={Note} />
      </Switch>
    )
  }
}

export default connect(null, { setItemState })(Schedule)



// WEBPACK FOOTER //
// ./src/containers/schedule/index.js